import { ABOUT_IMG, COMPANY } from "../data/site";
import { Reveal } from "../components/Reveal";
import { Target, Eye } from "lucide-react";

const About = () => (
  <div data-testid="page-about" className="bg-background">
    {/* HERO */}
    <section className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-6 flex flex-col justify-center">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-12 bg-[#C8102E]" />
              <span className="text-xs uppercase tracking-overline font-bold text-muted-foreground">
                About Us
              </span>
            </div>
            <h1 className="font-display font-black uppercase text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.95]">
              A trusted name in <br />
              <span className="text-[#C8102E]">automotive parts.</span>
            </h1>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-base md:text-lg text-muted-foreground leading-relaxed">
              Welcome to RNS Automobiles, your trusted destination for premium
              automobile spare parts. Conveniently located at NH34, Raninagar,
              Chuapur, Berhampore, West Bengal – 742102, we proudly serve
              customers with dependable automotive components and outstanding
              service.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-6">
          <Reveal delay={0.15}>
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="RNS Automobiles workshop"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute -bottom-1 -right-1 bg-[#C8102E] text-white px-5 py-4">
                <div className="font-display font-black text-3xl leading-none">
                  8+
                </div>
                <div className="text-[10px] uppercase tracking-overline mt-1">
                  Years of Trust
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    {/* BODY */}
    <section className="py-16 lg:py-20 bg-card">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 space-y-6">
        <Reveal>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Founded and led by{" "}
            <span className="text-foreground font-semibold">
              {COMPANY.owner}
            </span>
            , RNS Automobiles has earned a reputation for quality, reliability,
            and customer satisfaction. We specialize in supplying spare parts
            for Mahindra, Maruti Suzuki, and Tata vehicles, offering a
            comprehensive range of genuine and high-quality aftermarket
            components.
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Our extensive inventory includes engine components, brake systems,
            suspension parts, clutch assemblies, filters, bearings, electrical
            components, lubricants, steering parts, cooling system components,
            and many other essential automotive products.
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Whether you are a mechanic, workshop owner, retailer, fleet
            operator, or an individual vehicle owner, our experienced team is
            dedicated to helping you find the right part quickly and at a
            competitive price.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            We believe that long-term relationships are built on trust, quality,
            and exceptional service. Our goal is to ensure every customer
            receives dependable products, expert guidance, and a hassle-free
            purchasing experience.
          </p>
        </Reveal>
      </div>
    </section>

    {/* MISSION / VISION */}
    <section className="py-20 lg:py-24 bg-background">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-l border-border">
        {[
          {
            icon: Target,
            title: "Our Mission",
            body: "To provide genuine and high-quality automobile spare parts while delivering exceptional customer service, reliability, and value.",
          },
          {
            icon: Eye,
            title: "Our Vision",
            body: "To become one of India's most trusted automobile spare parts suppliers by consistently delivering quality products and customer-focused service.",
          },
        ].map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="border-r border-b border-border p-10 lg:p-14"
          >
            <div className="h-12 w-12 flex items-center justify-center bg-[#C8102E] text-white">
              <Icon className="h-6 w-6" />
            </div>
            <h3 className="mt-6 font-display font-black text-2xl md:text-3xl uppercase tracking-tighter">
              {title}
            </h3>
            <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed">
              {body}
            </p>
          </div>
        ))}
      </div>
    </section>

    {/* OWNER STRIP */}
    <section className="py-16 bg-[#111111] text-white">
      <div className="mx-auto max-w-4xl px-5 sm:px-8 text-center">
        <div className="inline-flex items-center justify-center bg-white px-4 py-2 rounded-sm mx-auto">
          <img
            src="/brand/rns-logo-wide.png"
            alt="RNS Automobile"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </div>
        <p className="mt-8 text-xs uppercase tracking-overline text-[#A7A9AC]">
          Founder &amp; Proprietor
        </p>
        <h3 className="mt-2 font-display font-black text-3xl md:text-4xl uppercase tracking-tighter">
          {COMPANY.owner}
        </h3>
        <p className="mt-4 text-[#A7A9AC] max-w-xl mx-auto">
          Committed to serving the automotive community of West Bengal with
          integrity, expertise and dependable spare parts since day one.
        </p>
      </div>
    </section>
  </div>
);

export default About;
